"use client";

import { useEffect } from "react";

interface CachedBranding {
  companyName: string;
  logo: string;
  primaryColor: string;
  secondaryColor: string;
  tertiaryColor: string;
}

export function BrandingCache({
  retailerId,
  branding,
}: {
  retailerId: string;
  branding: CachedBranding;
}) {
  useEffect(() => {
    try {
      sessionStorage.setItem(
        `plantista-branding-${retailerId}`,
        JSON.stringify(branding)
      );
    } catch {}
  }, [retailerId]);
  return null;
}
